export const RADIO_GROUP_NAV_ITEMS = [
  "email-templates",
  "promo-codes",
  "referral-partners",
  "pricing-plans",
  "sms-templates"
];

export const isRadioGroupNavItem = (slugName) =>
  RADIO_GROUP_NAV_ITEMS.includes(slugName);
